// ── Skeleton base ────────────────────────────────────────────────────────────
function Skeleton({ className = "", style = {} }) {
  return <div className={`blog-skeleton ${className}`} style={style} />;
}

// ── Featured card skeleton ────────────────────────────────────────────────────
export function FeaturedCardSkeleton() {
  return (
    <div className="blog-featured-card mb-4">
      <div className="row no-gutters">
        <div className="col-md-5">
          <Skeleton className="blog-skeleton--featured-img" />
        </div>
        <div className="col-md-7">
          <div className="blog-featured-card__body">
            <Skeleton
              style={{
                width: "90px",
                height: "22px",
                borderRadius: "3px",
                marginBottom: "12px",
              }}
            />
            <Skeleton
              style={{ width: "100%", height: "28px", marginBottom: "8px" }}
            />
            <Skeleton
              style={{ width: "85%", height: "28px", marginBottom: "16px" }}
            />
            <Skeleton
              style={{ width: "100%", height: "16px", marginBottom: "6px" }}
            />
            <Skeleton
              style={{ width: "100%", height: "16px", marginBottom: "6px" }}
            />
            <Skeleton
              style={{ width: "70%", height: "16px", marginBottom: "20px" }}
            />
            <Skeleton
              style={{ width: "80px", height: "12px", marginBottom: "20px" }}
            />
            <Skeleton
              style={{ width: "130px", height: "38px", borderRadius: "6px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Post card skeleton ────────────────────────────────────────────────────────
export function PostCardSkeleton() {
  return (
    <div className="blog-post-card">
      <Skeleton className="blog-skeleton--card-img" />
      <div className="blog-post-card__body">
        <Skeleton
          style={{
            width: "80px",
            height: "18px",
            borderRadius: "3px",
            marginBottom: "10px",
          }}
        />
        <Skeleton
          style={{ width: "100%", height: "18px", marginBottom: "6px" }}
        />
        <Skeleton
          style={{ width: "80%", height: "18px", marginBottom: "12px" }}
        />
        <Skeleton
          style={{ width: "100%", height: "13px", marginBottom: "5px" }}
        />
        <Skeleton
          style={{ width: "100%", height: "13px", marginBottom: "5px" }}
        />
        <Skeleton
          style={{ width: "60%", height: "13px", marginBottom: "12px" }}
        />
        <Skeleton
          style={{ width: "70px", height: "11px", marginBottom: "10px" }}
        />
        <Skeleton style={{ width: "80px", height: "13px" }} />
      </div>
    </div>
  );
}

// ── Blog index skeleton ───────────────────────────────────────────────────────
export function BlogIndexSkeleton() {
  return (
    <section className="container blog-index-container">
      <FeaturedCardSkeleton />
      <div className="blog-post-grid">
        {Array.from({ length: 6 }).map((_, i) => (
          <PostCardSkeleton key={i} />
        ))}
      </div>
    </section>
  );
}

// ── Blog post page skeleton ───────────────────────────────────────────────────
export function BlogPostSkeleton() {
  return (
    <section className="blog-post-page">
      <div className="container blog-post-container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10 col-lg-8">
            {/* category badge */}
            <Skeleton
              style={{
                width: "90px",
                height: "22px",
                borderRadius: "3px",
                marginBottom: "14px",
              }}
            />

            {/* title */}
            <Skeleton
              style={{ width: "100%", height: "36px", marginBottom: "8px" }}
            />
            <Skeleton
              style={{ width: "75%", height: "36px", marginBottom: "14px" }}
            />

            {/* meta */}
            <Skeleton
              style={{ width: "180px", height: "13px", marginBottom: "24px" }}
            />

            {/* hero image */}
            <Skeleton className="blog-skeleton--hero-img" />

            {/* content paragraphs */}
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} style={{ marginBottom: "20px" }}>
                <Skeleton
                  style={{ width: "100%", height: "15px", marginBottom: "6px" }}
                />
                <Skeleton
                  style={{ width: "100%", height: "15px", marginBottom: "6px" }}
                />
                <Skeleton
                  style={{ width: "100%", height: "15px", marginBottom: "6px" }}
                />
                <Skeleton
                  style={{
                    width: `${70 + Math.random() * 25}%`,
                    height: "15px",
                  }}
                />
              </div>
            ))}

            {/* share row */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "1.25rem 0",
                borderTop: "1px solid #e9ecef",
                borderBottom: "1px solid #e9ecef",
                marginBottom: "2rem",
              }}
            >
              <Skeleton style={{ width: "50px", height: "14px" }} />
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton
                  key={i}
                  style={{ width: "32px", height: "32px", borderRadius: "50%" }}
                />
              ))}
            </div>
          </div>
        </div>

        {/* related posts */}
        <div className="blog-related-section mt-2 mb-5">
          <Skeleton
            style={{ width: "200px", height: "24px", marginBottom: "1.5rem" }}
          />
          <div className="blog-post-grid">
            {Array.from({ length: 3 }).map((_, i) => (
              <PostCardSkeleton key={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
